module.exports = __webpack_public_path__ + "img/icon_syousya.d4c5fb3f.svg";